var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWrightTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6257 2.41018L6.3281 11.5862C6.07917 11.8614 5.7524 12 5.42562 12C5.09885 12 4.77208 11.8614 4.52315 11.5862L0.374455 6.99817C-0.124818 6.44629 -0.124818 5.55397 0.374455 5.00209C0.873495 4.44995 1.68014 4.44995 2.17941 5.00209L5.42562 8.59203L12.8208 0.414105C13.3198 -0.138035 14.1264 -0.138035 14.6257 0.414105C15.1248 0.965987 15.1248 1.85804 14.6257 2.41018Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWrightTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wright-tick.6efa17c5.svg";
export { ForwardRef as ReactComponent };